<template>
  <div class="schedule-item">
    <div class="columns is-mobile">
      <div class="column is-2 is-12-mobile">
        {{ item.presentation_time }}
      </div>
      <div class="column is-6 is-4-widescreen is-12-mobile">
        <a :href="item.url" target="_blank">
          {{ item.first }} {{ item.last }}</a
        >
      </div>
      <div class="column is-4 is-12-mobile">
        <lazy-component @show="handler">
          <span v-if="loading_slide">...</span>

          <div v-else>
            <a :href="item.slide_url" target="_blank">Slide</a>
            <span>|</span>
            <a :href="item.video_url" target="_blank">Video</a>

            <span>&nbsp;</span>
            <b-tooltip
              label="Make sure your slide is in the root of your website. FYI, this page only re-checks your links ever hour, but you can test yourself using the links."
              type="is-light"
              position="is-bottom"
              multilined
              v-if="!valid_slide || !valid_video"
            >
              <b-tag v-if="!valid_slide" type="is-warning">Missing slide</b-tag>
              <b-tag v-else-if="!valid_video" type="is-warning"
                >Missing video</b-tag
              >
            </b-tooltip>
          </div>
        </lazy-component>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["item"],
  data() {
    return {
      loading_video: false,
      loading_slide: false,
      valid_slide: false,
      valid_video: false
    };
  },
  mounted() {
    //do something after mounting vue instance
    // this.updateLinks(this.item)
    // this.updateLinks(this.item)
  },
  watch: {
    item: "updateLinks"
  },
  methods: {
    handler() {
      this.updateLinks(this.item);
    },
    updateLinks(item) {
      if (item) {
        this.checkSlide(item.slide_url);
        this.checkVideo(item.video_url);
      } else {
        this.loading_slide = false;
        this.valid_slide = false;
        this.loading_video = false;
        this.valid_video = false;
      }
    },
    checkSlide(slide_url) {
      if (slide_url) {
        this.loading_slide = true;
        this.valid_slide = false;
        this.checkFileURL(slide_url)
          .then(response => {
            // console.log('Slide state')
            if (response.success && response.status == 200) {
              this.valid_slide = true;
            }
            this.loading_slide = false;
          })
          .catch(() => {
            this.loading_slide = false;
          });
      }
    },
    checkVideo(video_url) {
      if (video_url) {
        this.loading_video = true;
        this.valid_video = false;
        this.checkFileURL(video_url)
          .then(response => {
            // console.log('Video state')
            if (response.success && response.status == 200) {
              this.valid_video = true;
            }
            this.loading_video = false;
          })
          .catch(() => {
            this.loading_video = false;
          });
      }
    },
    ...mapActions(["checkFileURL"])
  }
};
</script>
